module.exports = __webpack_public_path__ + "36610173ad3d979401c1fad4235c8e1a.svg";